export const COMMON_ACTIONS = {
  SET_VEHICLES: "SET_VEHICLES",
};
